import { render, staticRenderFns } from "./DdHimodukeHaishahyoAddButton.vue?vue&type=template&id=f07de228&scoped=true&"
import script from "./DdHimodukeHaishahyoAddButton.vue?vue&type=script&lang=js&"
export * from "./DdHimodukeHaishahyoAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07de228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
